import {
  Component,
  NgModule,
  ChangeDetectorRef,
  Output,
  Input,
  EventEmitter
} from "@angular/core";
import { PortService } from "../../port/port.service";
import { Observable, Subject } from "rxjs";
import { Port } from "../../port/model/port";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { RechercheOffresCommercialesForm } from "../model/form/rechercheOffresCommercialesForm";
import { OffrecommercialeService } from "../offrecommerciale.service";
import { PortSearchForm } from "../model/form/portSearchForm";
import { GeocodingService } from "../../geocoding.service";
import { Location } from "../../location";
import { MatSnackBar } from "@angular/material";
import { OffreLightByTypeTouche } from "../model/offreLightByTypeTouche";
import { RechercheOffresCommercialesFormNom } from "../model/form/rechercheOffreCommercialFormNom";
//import {NgSelectizeModule} from 'ng-selectize';
import "leaflet-wfst";

import {
  ASYNC_DROPDOWN_CONFIG,
  DEFAULT_VALUE_TIMEOUT,
  DEFAULT_OPTIONS_TIMEOUT
} from "./asyncConfig.config";
import { UserInformaions } from "../../common/userinformations";

import { TranslateService } from "@ngx-translate/core";
import { MarkerInfos } from "../../map/markerInfos";
import { IFilterAutoComplete } from "../model/IFilterAutoComplete";

declare var L: any;

@Component({
  selector: "simple-search",
  templateUrl: "./simplesearch.component.html",
  styleUrls: ["./simplesearch.component.scss"]
})
export class SimpleSearchComponent {
  /** Selectize */
  asyncOptionsConfig = ASYNC_DROPDOWN_CONFIG;
  currentValue: any;
  //recherchevalue: string;

  /*** */
  /*************** Const **************/
  DEFAULT_PORT: string = "Marseille - Fos";
  DISABLED = "disabled";
  EMPTY = "";
  ifok: boolean = false;
  BTN_PRIMARY = "btn-primary";
  BTN_DEFAULT = "btn-default";
  PORT_MARKER_NOT_VISIBLE = "MARSEILLE";

  /* declencher l'appel au parent afin d'afficher les valeurs du résultat de la recherche simple */
  @Output()
  rechercherOffrecommercialeEmitter = new EventEmitter<
    OffreLightByTypeTouche
  >();
  @Output()
  showAdvanceEmitter = new EventEmitter<void>();
  @Output()
  searchNoResultEmitter = new EventEmitter<void>();
  @Output()
  searchMapEmitter = new EventEmitter<MarkerInfos>();
  @Output()
  addMarkerEmitter = new EventEmitter<MarkerInfos>();
  @Output()
  aucunServicePourLePortRechercheEmitter = new EventEmitter<boolean>();

  searcheResult: OffreLightByTypeTouche;
  disabledSearch: boolean = true;
  btnPrimaryOrDefault = this.BTN_DEFAULT;

  /**********************************************************************************************/

  /*************** Décartations des observateurs pour l'autocompletion sur les ports ***************/
  portsFrom$: Observable<Port[]>;

  private fromSearchTerms = new Subject<PortSearchForm>();
  fromValue: Port;

  portsTo$: Observable<Port[]>;
  private toSearchTerms = new Subject<PortSearchForm>();
  toValue: Port;
  marseillePort: Port = new Port(
    null,
    this.DEFAULT_PORT,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  );

  portsTouches: Port[];
  /* */
  /** Formulaire de recherche */
  searchFormByIds: RechercheOffresCommercialesForm;
  searchFormModel: RechercheOffresCommercialesFormNom;
  /**/
  // asyncOptionsConfig = ASYNC_DROPDOWN_CONFIG;

  errorMessage: string;
  DISPLAY: boolean = false;
  langue: string;

  cpm2: any = 0;
  /* geocoding */
  portpluproche: Port;

  userInformations: UserInformaions;

  constructor(
    private portsService: PortService,
    private offreCommercialeService: OffrecommercialeService,
    private translate: TranslateService,
    private geocoder: GeocodingService
  ) {}

  ngOnInit() {
    this.langue = this.translate.currentLang;
    this.searchFormByIds = new RechercheOffresCommercialesForm(
      this.langue,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      false,
      null,
      null,
      null,
      null,
      null
    );
    this.searchFormModel = new RechercheOffresCommercialesFormNom(
      null,
      null,
      null,
      null,
      null,
      null,
      null
    );
    this.fromValue = this.marseillePort;
    this.portsFrom$ = this.getPortsObservable(this.fromSearchTerms);
    this.portsTo$ = this.getPortsObservable(this.toSearchTerms);
    this.translate.use(this.translate.currentLang);
  }

  /* Initialiser l'observateur qui récupère les ports selon la chaine de caractères introduite */
  getPortsObservable(searchTerms: Subject<PortSearchForm>): Observable<Port[]> {
    return searchTerms.pipe(
      // wait 30ms  each keystroke before considering the term
      // debounceTime(300),
      // ignore new term if same as previous term
      distinctUntilChanged(),
      // switch to new search observable each time the term changes
      switchMap((searchForm: PortSearchForm) =>
        this.portsService.getPortsByForm(searchForm)
      )
    );
  }

  displayFn(element?: IFilterAutoComplete): string | undefined {
    let valueToDisplay: string = "";
    /* Récupéraion de  la constante Marseille - Fos ici car il récupère this.DEFAULT_VALUE à null
       Une exception sur l'affichage de Marseille - Fos selon la spécification */
    let MARSEILLE_FOS: string = "Marseille - Fos";
    if (element && element.nom) {
      if (element.nom == MARSEILLE_FOS) {
        return MARSEILLE_FOS;
      }
      valueToDisplay =
        element.nom.charAt(0).toUpperCase() +
        element.nom.substr(1).toLowerCase();
    }
    return valueToDisplay;
  }

  /* Se déclenche à chaque modification de saisie dans le champs De/Vers 
  /* Elle Permet de récupèrer les ports selon la chaine de caractère introduite */
  searchPort(event, where: string): void {
    let term: string = event.target.value;

    this.disabledSearch = true;
    this.btnPrimaryOrDefault = this.BTN_DEFAULT;

    if (!term || term == "") {
      return;
    }
    let idPays: number = null;
    let searchForm: PortSearchForm = new PortSearchForm(
      idPays,
      term.toUpperCase()
    );

    switch (where) {
      case "FROM":
        this.fromValue = new Port(
          null,
          term,
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );
        this.fromSearchTerms.next(searchForm);
        this.toValue = this.marseillePort;
        break;
      case "TO":
        this.toValue = new Port(
          null,
          term,
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );
        this.toSearchTerms.next(searchForm);
        this.fromValue = this.marseillePort;
        break;
      default:
    }
  }
  switchPort() {
    let portTmp: Port = this.fromValue;
    this.fromValue = this.toValue;
    this.toValue = portTmp;
  }
  onPortSelected(event, where: string) {
    let port: Port = event.option.value;
    this.disabledSearch = false;
    this.btnPrimaryOrDefault = this.BTN_PRIMARY;

    switch (where) {
      case "FROM":
        if (port && port != this.marseillePort) {
          this.toValue = this.marseillePort;
        } else {
          this.fromValue = this.marseillePort;
        }
        break;
      case "TO":
        if (port && port != this.marseillePort) {
          this.fromValue = this.marseillePort;
        } else {
          this.toValue = this.marseillePort;
        }
        break;
      default:
    }
  }

  /** methode appelée depuis l'appui sur un marker */
  rechercheOffreCommercialeFromMarker(markerInfo: MarkerInfos) {
    this.disabledSearch = false;
    this.btnPrimaryOrDefault = this.BTN_PRIMARY;

    if (this.fromValue.nom == this.DEFAULT_PORT) {
      this.toValue = new Port(
        markerInfo.id,
        markerInfo.nom,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );
    } else {
      this.fromValue = new Port(
        markerInfo.id,
        markerInfo.nom,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      );
    }

    this.rechercheOffrecommerciale();
  }

  /*Recherche simple des offres commerciale */
  rechercheOffrecommerciale() {
    if (!this.toValue || !this.fromValue) {
      this.searchNoResultEmitter.emit();
      return;
    }

    let from: boolean = true;
    let portToUse: Port;

    /* remplissage du formulaire de recherche par nom afin de les afficher dans le résultat de la recherche avancé */

    if (this.fromValue.nom == this.DEFAULT_PORT) {
      portToUse = this.toValue;
      from = false;
    } else {
      portToUse = this.fromValue;
      from = true;
    }
    let isPortTouche: boolean = false;
    /* Si le port selectionné est un port touché */
    for (let i = 0; i < this.portsTouches.length; i++) {
      let idPortTouche = this.portsTouches[i].id;
      if (portToUse.id == idPortTouche) {
        isPortTouche = true;
        portToUse = this.portsTouches[i];
        break;
      }
    }

    if (!isPortTouche) {
      this.aucunServicePourLePortRechercheEmitter.emit(true);
      if (portToUse.lat == null && portToUse.lon == null) {
        this.rechercherParGeocodage(portToUse, from);
      } else {
        this.rechercherParPortDuReferentiel(portToUse, from);
      }
    } else {
      this.aucunServicePourLePortRechercheEmitter.emit(false);
      this.startRechercheOffreCommerciale(portToUse, from, false, null);
    }
  }

  /* Lorsque le port est connu du référentiel, on applique un géocodage pour prendre le port 
  touché le plus proche de lui */
  rechercherParPortDuReferentiel(portToUse: Port, from: boolean) {
    var nom = portToUse.nom;
    this.portsService.getPortById(portToUse.id).subscribe(data => {
      const best = data[0];
      const location = new Location();
      location.latlng = L.latLng(best.lat, best.lon);
      let locationStart = location.latlng;
      let distancecourent;
      for (let i = 0; i < this.portsTouches.length; i++) {
        const location = new Location();
        if (this.portsTouches[i].lat) {
          location.latlng = L.latLng(
            this.portsTouches[i].lat,
            this.portsTouches[i].lon
          );
        } else {
          location.latlng = L.latLng("1", "1");
        }
        let locationEnd = location.latlng;
        if (i == 0) {
          distancecourent = Math.round(
            locationStart.distanceTo(locationEnd) / 1000.0
          );
        }
        let distance = Math.round(
          locationStart.distanceTo(locationEnd) / 1000.0
        );
        if (distance < distancecourent) {
          portToUse = this.portsTouches[i];
          distancecourent = distance;
        } else if (distance == 0) {
          portToUse = this.portsTouches[i];
          distancecourent = distance;
          break;
        }
      }
      let markerLinked: MarkerInfos = new MarkerInfos(
        1,
        location.latlng,
        nom,
        "NO",
        "NO",
        true
      );
      this.startRechercheOffreCommerciale(portToUse, from, true, markerLinked);
      this.addMarkerEmitter.emit(markerLinked);
    });
  }
  /* Lorsque qu'on ne connait pas les coordonnées d'un port on le geocode et ensuite on 
  lance la recherche ud pot le pl*/
  rechercherParGeocodage(portToUse: Port, from: boolean) {
    var nom = portToUse.nom;
    this.geocoder
      .geocodesearchWFS(portToUse)
      .map((result: any) => {
        if (result.length === 0) {
          this.searchNoResultEmitter.emit();
          return;
        }
        return result;
      })
      .subscribe(data => {
        const best = data[0];
        const location = new Location();
        if (best.display_name && best.display_name.split(",")) {
          location.ADRESSE = best.display_name
            .split(",")[0]
            .toUpperCase()
            .trim();
        } else {
          location.ADRESSE = best.display_name.toUpperCase().trim();
        }
        location.latlng = L.latLng(best.lat, best.lon);
        let locationStart = location.latlng;
        let distancecourent;
        for (let i = 0; i < this.portsTouches.length; i++) {
          const location = new Location();
          if (this.portsTouches[i].lat) {
            location.latlng = L.latLng(
              this.portsTouches[i].lat,
              this.portsTouches[i].lon
            );
          } else {
            location.latlng = L.latLng("1", "1");
          }
          let locationEnd = location.latlng;
          if (i == 0) {
            distancecourent = Math.round(
              locationStart.distanceTo(locationEnd) / 1000.0
            );
          }
          let distance = Math.round(
            locationStart.distanceTo(locationEnd) / 1000.0
          );
          if (distance < distancecourent) {
            portToUse = this.portsTouches[i];
            distancecourent = distance;
          } else if (distance == 0) {
            portToUse = this.portsTouches[i];
            distancecourent = distance;
            break;
          }
        }
        let markerLinked: MarkerInfos = new MarkerInfos(
          1,
          location.latlng,
          nom,
          "NO",
          "NO",
          true
        );
        this.startRechercheOffreCommerciale(
          portToUse,
          from,
          true,
          markerLinked
        );
        this.addMarkerEmitter.emit(markerLinked);
      });
  }
  /*Appel du service back pour la recherche d'offres*/
  startRechercheOffreCommerciale(
    portToUse: Port,
    from: boolean,
    iscolor: boolean,
    markerLinked: MarkerInfos
  ) {
    if (from) {
      this.searchFormByIds.idPortImport = portToUse.id;
      this.searchFormModel.portImport = portToUse.nom;
      this.searchFormByIds.portImport = portToUse.nom;
      this.searchFormByIds.idPortExport = null;
      this.searchFormModel.portExport = null;
    } else {
      this.searchFormByIds.idPortExport = portToUse.id;
      this.searchFormModel.portExport = portToUse.nom;
      this.searchFormByIds.portExport = portToUse.nom;
      this.searchFormByIds.idPortImport = null;
      this.searchFormModel.portImport = null;
    }
    const location = new Location();
    location.latlng = L.latLng(portToUse.lat, portToUse.lon);
    if (location.latlng != null) {
      let markerInfos: MarkerInfos = new MarkerInfos(
        portToUse.id,
        location.latlng,
        portToUse.nom,
        portToUse.flag,
        portToUse.pays,
        iscolor
      );
      markerInfos.setLinkedMarker(markerLinked);
      this.searchMapEmitter.emit(markerInfos);
    }

    this.searchFormByIds.userInformations = this.userInformations;
    this.searchFormByIds.codeLangue = this.translate.currentLang;
    this.offreCommercialeService
      .getOffrescommercialesByForm(this.searchFormByIds)
      .subscribe(
        data => {
          let isData: boolean =
            data &&
            (Object.entries(data.direct).length > 0 ||
              Object.entries(data.transbo).length > 0)
              ? true
              : false;
          if (!isData) {
            this.searchNoResultEmitter.emit();
          } else {
            this.searcheResult = data;
            this.rechercherOffrecommercialeEmitter.emit(this.searcheResult);
          }
        },
        error => {
          this.errorMessage = <any>error;
        }
      );
  }

  showAdvanceForm() {
    this.showAdvanceEmitter.emit();
  }

  setUserInformations(userInformations: UserInformaions) {
    this.userInformations = userInformations;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/offrecommerciale/simplesearch/simplesearch.component.ts